import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { companyActions } from '../../../../../../redux/company/actions';
import { getExportingStatus, getLoadingStatus } from '../../../../../../redux/company/selectors';

export const ExportAnalysisButton = ({ companyData, action = '' }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const exporting = useSelector(getExportingStatus);
  const loading = useSelector(getLoadingStatus);

  return (
    <Button
      style={{ float: 'right', marginRight: '20px' }}
      disabled={loading}
      loading={exporting}
      onClick={() => dispatch(companyActions.exportCompanyAnalytics(companyData?._id, companyData?.name, action))}
    >
      {t('myCompanies.exportAnalytics')}
    </Button>
  );
};
